(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.clientHeight}px`);
      document.documentElement.style.setProperty('--header-sticky-offset', this.headerIsAlwaysSticky ? `${this.header.clientHeight}px` : '0px');
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.documentElement.style.setProperty('--header-sticky-offset', '0px');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.documentElement.style.setProperty('--header-sticky-offset', `${this.header.clientHeight}px`);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.documentElement.style.setProperty('--header-sticky-offset', '0px');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mg-video-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  const initVideoFaqSection = (sectionElement) => {
    if (!sectionElement) return;

    const sectionId = sectionElement.dataset.sectionId;
    console.log('Initializing Video + FAQ Section:', sectionId);

    // --- Logica voor openen FAQ item via URL hash (VERPLAATST NAAR BOVEN) ---
    const checkUrlHash = () => {
      const hash = window.location.hash.substring(1); // Verwijder de #
      console.log('[VideoFaq] Checking for hash:', hash);
      if (!hash) {
        console.log('[VideoFaq] No hash found.');
        return; // Doe niets als er geen hash is
      }

      // Probeer het element te vinden met een ID die *eindigt* op de hash
      // We gebruiken [id$="..."] omdat we de block.id ervoor hebben gezet
      const selector = `details[id$="-${hash}"]`;
      console.log('[VideoFaq] Attempting to find element with selector:', selector);
      const targetFaqElement = sectionElement.querySelector(selector);

      if (targetFaqElement) {
        console.log('[VideoFaq] Found FAQ item for hash:', hash, targetFaqElement);
        // Zorg ervoor dat alleen dit item open is (optioneel, sluit anderen)
        // sectionElement.querySelectorAll('details[open]').forEach(d => d.removeAttribute('open'));

        targetFaqElement.setAttribute('open', ''); // Open het gevonden item

        // Scroll naar het element voor zichtbaarheid
        // Wacht een fractie zodat de layout tijd heeft om bij te werken na openen
        setTimeout(() => {
          targetFaqElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100); // Kleine vertraging
      } else {
        console.log('[VideoFaq] No FAQ item found for hash:', hash);
      }
    };

    // Voer de hash check meteen uit
    console.log('[VideoFaq] About to call checkUrlHash (early) for section:', sectionId);
    checkUrlHash();

    // --- Logica voor Externe Video (iframe direct laden) - Geen JS nodig hier ---

    // --- Logica voor Gehoste Video (klik om te pauzeren/spelen) ---
    const hostedVideoPlayer = sectionElement.querySelector('[data-hosted-video-player]');
    if (hostedVideoPlayer) {
      // Verwijder oude listener als die bestaat (voor Theme Editor reloads)
      const oldListener = hostedVideoPlayer.clickListener;
      if (oldListener) {
        hostedVideoPlayer.removeEventListener('click', oldListener);
      }

      // Definieer de nieuwe listener functie
      const newListener = (event) => {
         // Logica blijft hetzelfde, alleen preventDefault() verplaatst

         // Voorkom dat klikken op de controls zelf de video pauzeert/start
         if (event.target === hostedVideoPlayer) {
            event.preventDefault(); // Voorkom standaard browser actie HIER
            console.log('Hosted video click event on surface:', event);
            console.log('Paused state BEFORE toggle:', hostedVideoPlayer.paused);
            if (hostedVideoPlayer.paused) {
                hostedVideoPlayer.play();
            } else {
                hostedVideoPlayer.pause();
            }
            // Log status kort na actie
            setTimeout(() => {
               console.log('Paused state AFTER toggle:', hostedVideoPlayer.paused);
            }, 50); // Iets langere timeout voor de zekerheid
         } else {
           // console.log('Click was on controls, not video surface. Ignoring.');
         }
      };

      // Voeg nieuwe listener toe en bewaar referentie
      hostedVideoPlayer.addEventListener('click', newListener);
      hostedVideoPlayer.clickListener = newListener; // Sla referentie op om later te kunnen verwijderen

      console.log('Click-to-play/pause listener added for hosted video in section:', sectionId);
    }

    // --- Logica voor openen FAQ item via URL hash ---
    /* Verplaatst naar boven
    const checkUrlHash = () => {
      ...
    };
    */

    // Voer de hash check uit
    // console.log('[VideoFaq] About to call checkUrlHash for section:', sectionId); // Verplaatst naar boven
    // checkUrlHash(); // Verplaatst naar boven

  }; // Einde initVideoFaqSection

  // Initialiseer alle secties op de pagina
  document.querySelectorAll('[data-section-type="video-faq"]').forEach(initVideoFaqSection);

  // Her-initialiseer bij section load in Theme Editor
  document.addEventListener('shopify:section:load', function(event) {
    const sectionId = event.detail.sectionId;
    const sectionElement = document.querySelector(`[data-section-id="${sectionId}"][data-section-type="video-faq"]`);
    if (sectionElement) {
        console.log('Re-initializing Video + FAQ section on shopify:section:load', sectionId);
        initVideoFaqSection(sectionElement);
    }
  });

  // Optioneel: logica voor section select/deselect indien nodig
  document.addEventListener('shopify:section:select', function(event) {
    // ...
  });
  document.addEventListener('shopify:section:deselect', function(event) {
     // ...
  });

}); // Einde DOMContentLoaded

  } catch(e) { console.error(e); }
})();
})();
